import React, { useContext, useState } from "react";
import LoaderHelper from "../../../Services/Loading/LoaderHelper";
import AuthService from "../../../Services/ApiServices/AuthService";
import { alertErrorMessage, alertSuccessMessage } from "../../../Services/CustomAlertModel";
import { Link, useNavigate } from "react-router-dom";
import { ProfileContext } from "../../../Services/ProfileProvider";

const Signup = () => {

	const [signUpData, setSignUpData] = useState({ emailId: "", password: "" });
	const [showPass, setshowPass] = useState(false);
	const userId = window.location.href.split("=")[1];
	const [checkButton, setCheckButton] = useState(false);
	const { setLoginDetails } = useContext(ProfileContext);

	const navigate = useNavigate();

	const validateEmail = (email) => {
		// Basic email structure validation
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!emailRegex.test(email)) {
			console.error("Invalid email format");
			alertErrorMessage("Please enter a valid email address.");
			return false;
		}

		// Domain validation
		const validDomains = ["gmail.com", "yahoo.com", "outlook.com", "hotmail.com", "appinop.com", "live.com"];
		const emailParts = email.split("@");
		if (emailParts.length === 2) {
			const domain = emailParts[1].toLowerCase();
			if (!validDomains.includes(domain)) {
				console.error("Invalid email domain:", domain);
				alertErrorMessage("Invalid email domain. Please use a valid email domain.");
				return false;
			}
		} else {
			alertErrorMessage("Invalid email format. Please include a valid domain.");
			return false;
		}

		return true; // Email is valid
	};

	const validatePassword = (password) => {
		const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{5,}$/;

		if (!passwordRegex.test(password)) {
			console.error("Invalid password format");
			alertErrorMessage("Password must include at least one letter, one number, one special character, and be at least 5 characters long.");
			return false;
		}
		return true;
	};

	
    const handleSpaces = (e) => {
        if (e.key === ' ') {
            e.preventDefault();
        };
    };



	const handleSignUp = async () => {
		if (!signUpData.emailId || !signUpData.password) {
			alertErrorMessage("Please Enter Email Address");
			return
		} if (!checkButton) {
			alertErrorMessage("Please Check terms & Conditions");
			return
		} if (!validateEmail(signUpData.emailId)) {
			console.error("Email validation failed.");
			return; 
		} if (!validatePassword(signUpData.password)) {
			console.error("Password must include at least one letter, one number, one special character, and be at least 5 characters long.");
			return;
		}
		LoaderHelper.loaderStatus(true);
		try {
			const result = await AuthService.register(signUpData.emailId, signUpData.password, userId);
			LoaderHelper.loaderStatus(false);
			if (result?.success) {
				alertSuccessMessage(result?.message);
				/* setLoginDetails(result.token);
				localStorage.setItem("token", result.token);
				localStorage.setItem("emailId", result.data.emailId);
				localStorage.setItem("user_id", result.data.user_id); */
				navigate("/")
			} else {
				alertErrorMessage(result);
			};
		} catch (error) {
			alertErrorMessage(error);
		}
		finally { LoaderHelper.loaderStatus(false); }
	};

	const handleInputChange = (event) => {
		const { name, value } = event.target;
		setSignUpData({ ...signUpData, [name]: value });
	};



	return (
		<section class="section-padding login_sec">
			<div class="container">
				<div class="row">
					<div class="col-lg-6 col-12 mx-auto">
						<div class=" text-center  mb-4">
							<img src="assets/images/logo.svg" className="navbar-brand" alt="" />
						</div>
						<form class="custom-form ticket-form mb-5 mb-lg-0">
							<div className="login_form" >
								<div class=" d-block text-center mb-5">
									<h3 class=" text-gradient"> <strong>Welcome to VRFX</strong> </h3>
									<p>Enter details to create your new Account</p>
								</div>
								<div class=" cfield_group login_group">
									<label class="mb-2"> Email Id </label>
									<div class="cfield mb-3">
										<input type="text" className="form-control" name="emailId" placeholder="Enter Email"
											value={signUpData.emailId.toLowerCase()} onChange={handleInputChange} onKeyDown={handleSpaces}
										/>
									</div>
								</div>
								<div class=" cfield_group login_group">
									<label class="mb-2">  Password </label>
									<div class="cfield mb-3 ">
										<div class=" field-otp-box">
											<input type={showPass ? 'text' : 'password'} name="password" className="form-control" placeholder="Enter Password"
												value={signUpData.password} onChange={handleInputChange} onKeyDown={handleSpaces}
											/>
											<button type="button" class="btn btn-icon btn_view_pass btn-white"
												onClick={() => setshowPass(!showPass)}>
												<i className={`ri-eye${showPass ? "-line" : "-off-line"}`} /></button>
										</div>
									</div>
								</div>
								<div class=" cfield_group login_group ">
									<div class="form-check ">
										<input class="form-check-input cursor-pointer" type="checkbox" id="flexCheckDefault" value={checkButton} onClick={() => setCheckButton((prev) => !prev)} />
										<label class="form-check-label cursor-pointer" for="flexCheckDefault">
											I confirm that I am not a citizen, resident, or affiliate of the U.S. or a resident of the Philippines.
											<br />
										</label>
									</div>
								</div>
								<button type="button" class="btn custom-btn btn-gradient btn-border  w-100 mt-3" onClick={handleSignUp}><span>REGISTER</span></button>

							</div>
							<div className="col-12 text-center mt-2">
								<p>Do you have an account? <Link className="fw-bold" to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Log in</Link></p>
							</div>
						</form>
					</div>
				</div>
			</div>
		</section>
	)
}

export default Signup


